// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list-item-group .v-list-item--active{color:inherit}", ""]);
// Exports
module.exports = exports;
